import React, { useState, useEffect, useCallback } from 'react';
import ChatDashboard from '../../components/chat/components/ChatDashboard';

const MessagesPage = () => {
  const [headerHeight, setHeaderHeight] = useState(0);

  const updateHeaderHeight = useCallback(() => {
    const header = document.getElementById('sticky-menu');
    if (header) {
      setHeaderHeight(header.offsetHeight);
    }
  }, []);

  useEffect(() => {
    updateHeaderHeight();

    window.addEventListener('resize', updateHeaderHeight);

    const header = document.getElementById('sticky-menu');
    let observer;
    if (header && typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(updateHeaderHeight);
      observer.observe(header);
    }

    // Inject a style tag to move Chatwoot widget to left side
    // so it doesn't overlap the message input.
    // Using a <style> tag with broad selectors is more reliable than
    // querying for specific elements that may not exist yet.
    const style = document.createElement('style');
    style.id = 'horus-chat-widget-override';
    style.textContent = `
      [class*="woot"], [id*="chatwoot"],
      .woot-widget-bubble, .woot--bubble-holder, .woot-widget-holder {
        right: auto !important;
        left: 20px !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      window.removeEventListener('resize', updateHeaderHeight);
      observer?.disconnect();
      // Remove the override style on unmount
      const s = document.getElementById('horus-chat-widget-override');
      if (s) s.remove();
    };
  }, [updateHeaderHeight]);

  return (
    <div className="chat-page-container" style={{ paddingTop: headerHeight }}>
      <ChatDashboard />
    </div>
  );
};

export default MessagesPage;
